import React from 'react';

const PodDispatchComponentLoadable = React.lazy(() => import('./PodDispatchComponent'));

export {
    PodDispatchComponentLoadable
};
